import { AppBar, Box, BoxProps, IconButton } from "@mui/material"
import { Logout } from "@mui/icons-material"
import { ReactComponent as ListIcon } from "./images/logo_tsunagu_store.svg"
import { signOut } from "aws-amplify/auth"

export const Header = (props: BoxProps) => {
    const onLogoutButtonClick = () => {
        signOut().then().catch()
    }

    return (
        <Box {...props}>
            <AppBar component="header" position="relative" elevation={1} sx={{ borderWidth: 0, height: 64, backgroundColor: "transparent" }}>
                <Box display={"flex"} justifyContent={"space-between"}>
                    <Box display={"flex"}>
                        <ListIcon height={64} />
                        <Box display={"flex"} alignContent={"center"} paddingLeft={2}>
                        </Box>
                    </Box>
                    <Box alignContent={"center"} justifyContent={"end"}>
                        {<IconButton color="primary" sx={{ fontSize: 12 }} onClick={onLogoutButtonClick}><Logout />Logout</IconButton>}
                    </Box>
                </Box>
            </AppBar>
        </Box>
    )
}

